module.exports = __webpack_public_path__ + "static/media/Leave1.0b364fa7.svg";